import { first } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ToasterService } from '@abp/ng.theme.shared';
import { ActivatedRoute, Router } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { LocalizationModule } from '@abp/ng.core';
import {
  SupplierDeliveryNoteService,
  SupplierPurchaseOrderToSelect,
} from '@digiwall/goliath-documents/proxy';
import { DialogBoxComponent, TableComponent, TableRowComponent } from '@digiwall/ui-kit';
import { CurrencyStore } from '@digiwall/goliath-core';
import { OdysseyOffcanvas } from '@digiwall/core';

@Component({
  selector: 'document-dialog-box-select-sales-purchase',
  templateUrl: 'dialog-box-select-sales-purchase.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxValidateCoreModule,
    LocalizationModule,
    DialogBoxComponent,
    TableComponent,
    TableRowComponent,
  ],
})
export class DialogBoxSelectSalesPurchaseComponent implements OnInit {
  @Input() documentId: string;
  @Input() supplierId: string;
  @Input() docService: SupplierDeliveryNoteService;
  @Input() isSerialEntry: boolean = false;
  @Input() closeFn: (purchaseOrderSelectedId: string[]) => void;
  currencyStore = inject(CurrencyStore);

  protected supplierPuchaseOrderList: SupplierPurchaseOrderToSelect[];
  private purchaseOrderSelectedId: Array<string>;
  protected offcanvasService = inject(OdysseyOffcanvas);

  constructor(
    protected toastService: ToasterService,
    protected router: Router,
    protected route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.docService
      .getSupplierPurchaseOrderToSelect(this.supplierId, this.isSerialEntry)
      .subscribe((response: SupplierPurchaseOrderToSelect[]) => {
        this.supplierPuchaseOrderList = response;
      });
  }

  protected getCurrency(currencyId: string) {
    const currency = this.currencyStore.entities().filter(x => x.id == currencyId)[0];
    return currency.name.current + ' - ' + currency.code;
  }

  protected clone() {
    if (this.isSerialEntry) {
      this.closeFn(this.purchaseOrderSelectedId);
      this.offcanvasService.dismiss();
    } else {
      this.docService
        .createDeliveryNoteLines(this.documentId, this.purchaseOrderSelectedId)
        .subscribeOnce(() => {
          this.offcanvasService.dismiss();
        });
    }
  }
  protected selectionChange(rows: Array<TableRowComponent>) {
    this.purchaseOrderSelectedId = rows.filter(x => x.selected).map(x => x.data.id);
  }

  protected canSelectLine(purchaseOrder: SupplierPurchaseOrderToSelect): boolean {
    return this.isSerialEntry || !purchaseOrder.isSerial;
  }
}
